import Evented from './Evented';
/**
 * Channel used for client subscriptions within a multiplexed connection
 */
export default class MultiplexChannel extends Evented {
    constructor(host, channelPath, opts) {
        super();
        this.lastMessageSequence = 0;
        this.subscribers = 0;
        this.host = host;
        this.channelPath = channelPath;
        this.options = opts;
        this.subscribe();
    }
    get isConnected() { return this.host.isConnected; }
    get metrics() {
        return {
            channelPath: this.channelPath,
            subscribers: this.subscribers,
            lastMessageSequence: this.lastMessageSequence
        };
    }
    subscribe() {
        if (this.subscribers < 1) {
            this.host.subscribeToChannel(this);
        }
        this.subscribers = this.subscribers + 1;
    }
    unsubscribe() {
        this.subscribers -= 1;
        if (this.subscribers < 1) {
            this.host.unsubscribeFromChannel(this);
            this.lastMessageSequence = 0;
            this.emit('destroy');
        }
    }
}
//# sourceMappingURL=MultiplexChannel.js.map